export default function showFormErrors(all: { field: string, message: string }[]) {
  const text = all.reduce((prev, curr) => (prev + curr.field + ' ' + curr.message + '\n'), '');
  alert(text);
}
